import {
  ExploreImageProvider,
  useExploreImage,
} from "components/discovery/explore-image/ExploreImageContext";
import { UploadMatchAccordion } from "components/discovery/explore-image/results/sidebar/UploadMatchAccordion";
import { UPLOADED_FILE_STATE_KEY } from "components/discovery/explore-image/upload/uploadHandoff";
import { CATEGORY_TAB_ID } from "components/navigation/categoryNavItems";
import { useFeatureFlags } from "hooks/use-config";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Hands a validated image over to the start page's Upload & Match flow as soon
 * as the uploader stores it (CX-3746). Only the `File` travels in router
 * state; the start page creates its own object URL.
 */
const UploadedFileHandoff = () => {
  const { state } = useExploreImage();
  const navigate = useNavigate();

  useEffect(() => {
    const file = state.uploadedFile;
    if (!file) {
      return;
    }
    navigate("/", {
      state: {
        requestedTab: CATEGORY_TAB_ID.IMAGE,
        [UPLOADED_FILE_STATE_KEY]: file,
      },
    });
  }, [state.uploadedFile, navigate]);

  return null;
};

const noop = () => undefined;

/**
 * Empty "Upload & Match" accordion at the top of the /search sidebar, so the
 * sidebar offers the same options as the start page's Upload & Match view. It
 * only renders the placeholder dropzone; the flow itself runs on the start
 * page.
 */
export const SearchUploadMatch = () => {
  const flags = useFeatureFlags();
  if (!flags.uploadMatch) {
    return null;
  }

  return (
    <ExploreImageProvider>
      <UploadedFileHandoff />
      <UploadMatchAccordion
        hasReferenceImage={false}
        imageSrc=""
        palette={[]}
        selectedColorIndex={0}
        onColorSelect={noop}
        onChangeClick={noop}
      />
    </ExploreImageProvider>
  );
};
